{
  "COMMON": {
    "MEETING_ANALYSIS": "Meeting Analysis",
    "SUMMARY": "Summary",
    "PARTICIPANTS": "Participants",
    "KEY_TAKEAWAYS": "Key Takeaways",
    "ACTION_ITEMS": "Action Items",
    "TIME": "Time",
    "DATE": "Date",
    "DURATION": "Duration",
    "GOOGLE_MEET": "Google Meet",
    "ZOOM": "Zoom",
    "MICROSOFT_TEAMS": "Microsoft Teams",
    "TRACKERS": "Trackers",
    "KEYWORD_TRACKERS": "Keyword trackers",
    "KEYWORDS": "Keywords",
    "TRANSCRIPT": "Transcript",
    "GUESTS": "Guests",
    "DETAILS": "Details",
    "CONTACTS": "Contacts",
    "SHARE": "Share",
    "CANCEL": "Cancel",
    "COPY_LINK": "Copy link",
    "SAVE": "Save"
  },
  "MEETING_DETAILS": {
    "MEETING_DETAILS": "Meeting details",
    "SENTIMENT_ANALYSIS": "Sentiment analysis",
    "SENTIMENT_SCORE": "Sentiment score",
    "MEETING_METRICS": "Meeting metrics",
    "MEETING_TITLE": "Meeting title",
    "SCHEDULED_ON": "Scheduled on",
    "SALES_SCORE": "Sales score",
    "ATTENDEES": "Attendees",
    "TEAM_MEMBERS": "Team members",
    "RECORDING": {
      "LOADING_ERROR": "Error loading recording, please try again."
    }
  },
  "TRANSCRIPT": {
    "TRANSCRIPT_NOT_AVAILABLE_TITLE": "Transcript not available",
    "TRANSCRIPT_NOT_AVAILABLE_DESCRIPTION_V2": "The transcript is not available for this meeting.",
    "DOWNLOAD_TRANSCRIPT": "Download transcript",
    "DOWNLOAD_WILL_START_SHORTLY": "Your download will start shortly",
    "TRY_AGAIN": "There was an error downloading the transcript. Please try again later."
  },
  "RECORDING": {
    "URL_COPIED": "Copied!"
  },
  "CALLS": {
    "TITLE": "Calls"
  },
  "COPIED_SUCCESSFULLY": "Copied successfully to clipboard",
  "SCHEDULE_BOT": {
    "DESCRIPTION_V2": "To add your AI Sales Assistant to a Google Meet or Microsoft Teams meeting, enter the meeting URL below, as provided in the meeting invitation. Make sure the meeting is active or scheduled to start in the next few minutes.",
    "MEETING_URL": "Meeting URL",
    "PLACEHOLDER": "https://example.com/your-meeting-id",
    "SEND_NOW": "Add now",
    "SUCCESS_V2": "Your AI Sales Assistant has been scheduled to join the meeting as soon as possible.",
    "ERROR": "There was an error scheduling your AI Sales Assistant. Please try again.",
    "JOIN_MEETING_V2": "Add AI Sales Assistant to a meeting"
  },
  "SHARE": {
    "TITLE": "Share meeting details",
    "DESCRIPTION": "Anyone at your organization can view this page.",
    "AT_CURRENT_TIME": "Start video at ",
    "AT_BEGINNING": "Start video at the beginning"
  },
  "SALES_COACH_CONFIG": {
    "MEETING_SETTINGS": "Meeting recording settings",
    "CALENDAR_CONNECTION_CARD": {
      "TITLE": "Your calendar connection",
      "DESCRIPTION": "Each member of your team will need to connect their own Google Meet account",
      "ACTION": "Manage your connection"
    },
    "FORM": {
      "TITLE": "Meeting recording",
      "DESCRIPTION": "The AI Sales Assistant will automatically join, record, and transcribe meetings in the connected calendars.",
      "DISPLAY_NAME": {
        "TITLE": "Meeting display name",
        "DESCRIPTION": "The AI Sales Assistant will use this name when joining meetings"
      },
      "CONSENT": {
        "TITLE": "Play recording announcement when recording starts",
        "DESCRIPTION": "When selected, the AI Sales Assistant will play an audio clip when it joins the meeting, saying \"This meeting is being recorded for quality and notetaking purposes\""
      }
    },
    "MODAL": {
      "TITLE": "Save meeting recording settings?",
      "DESCRIPTION": "These settings can only be updated once per hour."
    },
    "ERROR_LOADING_CONFIG": "Error loading configuration, please try again.",
    "ERROR_SAVING_CONFIG": "Error saving configuration, please try again.",
    "CONFIG_SAVED": "Configuration saved successfully."
  }
}
